import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BillingProductCategory } from '@src/types'
import { productsByCategorySelector } from '@src/selectors/app'
import { useEstimatedProductPrices } from './useEstimatedProductPrices'

export const useLabPanelsProducts = () => {
  const dispatch = useDispatch()
  const products = useSelector(productsByCategorySelector(BillingProductCategory.Labs))

  useEffect(() => {
    dispatch({
      type: 'app/fetchProducts',
      payload: { category: BillingProductCategory.Labs },
    })
  }, [dispatch])

  const purchasableItems = useMemo(
    () =>
      products.map((product) => ({
        product,
        quantity: 1,
      })),
    [products],
  )

  const { estimatedProductPrices, loading, error, reload } = useEstimatedProductPrices({
    purchasableItems,
  })

  return { products, estimatedProductPrices, loading, error, reload }
}
